<template>
  <div>
    <div
      style="margin-top: -25px; background: #f8f8ff"
      v-if="
        $sessionsStorage.get('designation') == 'Admin' &&
        $sessionsStorage.get('userLevel') == '1'
      "
    >
      <div>
        <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
        <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
      </div>

      <div class="page-header">
        <h1 class="page-title">
          <span class="subpage-title">Custom Clearance Export Reports</span>
        </h1>

        <div class="ml-auto"></div>

        <div class="input-group">
          <date-picker
            v-model="searchModal.dateRangeCC"
            range
            :lang="langCC"
            format="YYYY-MM-DD"
            confirm
            @change="onConfirmDateRangeCC"
          ></date-picker>
          <!-- <a
            style="margin-left:10px"
            @click="onDownloadPDF('3')"
            class="btn btn-warning btn-icon text-white mr-2"
            id="daterange-btn"
            data-toggle="tooltip"
            title
            data-placement="bottom"
            data-original-title="Calendar"
          >
            <span>
              <i class="fa fa-file-pdf-o"></i>
            </span>
          </a>-->
          <a
            style="margin-left: 10px"
            @click="onDownloadExcel('1')"
            class="btn btn-warning btn-icon text-white mr-2"
            id="daterange-btn"
            data-toggle="tooltip"
            title
            data-placement="bottom"
            data-original-title="Calendar"
          >
            <span>
              <i class="fa fa-file-excel-o"></i>
            </span>
          </a>
        </div>
      </div>

      <md-card-content style="background: beige">
        <b-table
          class="table table-bordered table-striped"
          show-empty
          stacked="md"
          :items="filteredCC"
          :fields="fieldsCC"
          :per-page="perPageCC"
          :sort-by.sync="sortByCC"
          :sort-desc.sync="sortDescCC"
          :sort-direction="sortDirectionCC"
          striped
        >
          <template slot="top-row" slot-scope="{ fields }">
            <td
              style="background: #43377b"
              v-for="fieldC in fields"
              :key="fieldC.key"
            >
              <input
                style="
                  width: 130px;
                  height: 25px;
                  border-radius: 5px;
                  font-size: 12px;
                  text-align: center;
                "
                v-model="filtersCC[fieldC.key]"
                :placeholder="fieldC.label"
                @input="getAdvanceSearchDataCC('0', '1')"
              />
            </td>
          </template>
          <template slot="clientName" slot-scope="row1">
            <b>{{ row1.item.clientName }}</b>
            <br />
            Assignment No :
            {{ row1.item.ccImportSeries }}
            <br />
            Assignment Date :
            {{ row1.item.loginTime | moment }}
          </template>
        </b-table>
        <div class="pull-right">
          <b-pagination
            v-model="currentPageCC"
            :per-page="perPageCC"
            :total-rows="totalRowsCC"
            @change="onPageChangeCC($event)"
          ></b-pagination>
        </div>
      </md-card-content>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import DatePicker from "vue2-datepicker";
import { URL_BASE } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../../helper/collection";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/dashboard");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != "" &&
      this.$sessionsStorage.get("departmentName") != undefined &&
      this.$sessionsStorage.get("departmentName") != "" &&
      this.$sessionsStorage.get("designation") != undefined &&
      this.$sessionsStorage.get("designation") != ""
    ) {
      this.getData();
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    // Loading
    CustomLoader,
  },
  computed: {
    filteredTPT() {
      const filtered = this.tptSearchData.filter((item) => {
        return Object.keys(this.filtersTPT).every((key) =>
          String(item[key])
            .toLowerCase()
            .includes(this.filtersTPT[key].toLowerCase())
        );
      });

      return filtered.length > 0
        ? filtered
        : [
            // {
            //   clientName: "",
            //   type: "",
            //   fromLocation: "",
            //   toLocation: "",
            //   multipleContainerType: "",
            //   shipLine: ""
            // }
          ];
    },
    filteredFF() {
      const filteredF = this.freightTrackDataExpo.filter((item) => {
        return Object.keys(this.filtersFF).every((key) =>
          String(item[key])
            .toLowerCase()
            .includes(this.filtersFF[key].toLowerCase())
        );
      });
      return filteredF.length > 0
        ? filteredF
        : [
            // {
            //   clientName: "",
            //   type: "",
            //   fromLocation: "",
            //   toLocation: "",
            //   multipleContainerType: "",
            //   shipLine: ""
            // }
          ];
    },
    filteredCC() {
      const filteredC = this.CCTrackDataImp.filter((item) => {
        return Object.keys(this.filtersCC).every((key) =>
          String(item[key])
            .toLowerCase()
            .includes(this.filtersCC[key].toLowerCase())
        );
      });
      return filteredC.length > 0
        ? filteredC
        : [
            // {
            //   clientName: "",
            //   type: "",
            //   fromLocation: "",
            //   toLocation: "",
            //   multipleContainerType: "",
            //   shipLine: ""
            // }
          ];
    },
  },
  data() {
    return {
      selectDateFormat,
      showChart: false,
      seriesTPT1: [],
      chartOptionsTPT1: {
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },

      seriesTPT5: [15, 16],
      chartOptionsTPT5: {
        labels: ["tpt", "ff"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },

      seriesTPT3: [
        {
          data: [],
        },
      ],
      chartOptionsTPT3: {
        labels: [],
        chart: {
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: "smooth",
        },
        markers: {
          size: 6,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },

        xaxis: {
          categories: [],
          title: {
            text: "Month",
          },
        },
        yaxis: {
          title: {
            text: "Number of Assignment",
          },
        },
        legend: {
          position: "right",
          offsetY: 40,
        },
        fill: {
          opacity: 1,
        },
      },
      langCC: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      langFF: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      langTPT: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      searchModal: {
        dateRangeFF: "",
        dateRangeCC: "",
        dateRangeTPT: "",
      },
      perPageTPT: 5,
      sortDescTPT: false,
      sortByTPT: null,
      sortDirectionTPT: "asc",
      totalRowsTPT: 0,
      currentPageTPT: 1,
      tptSearchData: [],
      filtersTPT: {
        clientName: "",
        type: "",
        fromLocation: "",
        toLocation: "",
        multipleContainerType: "",
        ContainerNo: "",
        shipLine: "",
      },
      columnsTPTpdf: [
        "AssignmentNo",
        "Client",
        "Export_Import",
        "Handover",
        //  "InvoiceDate",
        //  "InvoiceNo",
        "Pickup",

        "ContainerNo",
        "ContainerType",
        "shipLine",
      ],
      fieldsTPT: [
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Search Client",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          thStyle: {
            display: "none",
          },
        },
        {
          key: "type",
          mainkey: "type",
          label: "Search Export / Import",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          thStyle: {
            display: "none",
          },
        },
        {
          key: "fromLocation",
          mainkey: "fromLocation",
          label: "Search Pickup",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          thStyle: {
            display: "none",
          },
        },
        {
          key: "toLocation",
          mainkey: "toLocation",
          label: "Search Handover",
          table: "C.",
          sortable: true,
          sortDirection: "ASC",
          thStyle: {
            display: "none",
          },
        },
        {
          key: "multipleContainerType",
          mainkey: "multipleContainerType",
          label: "Search Container Type",
          table: "C.",
          sortable: true,
          sortDirection: "ASC",
          thStyle: {
            display: "none",
          },
        },
        {
          key: "ContainerNo",
          mainkey: "ContainerNo",
          label: "Search Container",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
          thStyle: {
            display: "none",
          },
        },
        {
          key: "shipLine",
          mainkey: "shipLine",
          label: "Search Shipping Line",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
          thStyle: {
            display: "none",
          },
        },
      ],
      fieldsFF: [
        {
          key: "clientName",
          mainkey: "clientName",
          table: "C.",
          label: "Search Shipper",
          sortable: true,
          sortDirection: "ASC",
          thStyle: {
            display: "none",
          },
        },
        {
          key: "consignee",
          mainkey: "consignee",
          table: "A.",
          label: "Search Consignee",
          sortable: true,
          sortDirection: "ASC",
          thStyle: {
            display: "none",
          },
        },
        {
          key: "containerNo",
          mainkey: "containerNo",
          table: "E.",
          label: "Search Container",
          sortable: true,
          sortDirection: "ASC",
          thStyle: {
            display: "none",
          },
        },

        {
          key: "shippingLine",
          mainkey: "shippingLine",
          table: "D.",
          label: "Search ShippingLine",
          sortable: true,
          sortDirection: "ASC",
          thStyle: {
            display: "none",
          },
        },

        {
          key: "portDischarge",
          mainkey: "portDischarge",
          table: "A.",
          label: "Search POD",
          sortable: true,
          sortDirection: "ASC",
          thStyle: {
            display: "none",
          },
        },
        {
          key: "placeReceipt",
          mainkey: "placeReceipt",
          table: "A.",

          label: "Search POR",
          sortable: true,
          sortDirection: "ASC",
          thStyle: {
            display: "none",
          },
        },
      ],
      filtersFF: {
        clientName: "",
        consignee: "",
        containerNo: "",
        //    shippingBillNo: "",
        shippingLine: "",
        portDischarge: "",
        placeReceipt: "",
      },
      perPageFF: 5,
      sortDescFF: false,
      sortByFF: null,
      sortDirectionFF: "asc",
      freightTrackDataExpo: [],
      totalRowsFF: 0,
      currentPageFF: 1,
      //
      fieldsCC: [
        {
          key: "clientName",
          mainkey: "clientName",
          table: "G.",
          label: "Search Shipper",
          sortable: true,
          sortDirection: "ASC",
          thStyle: {
            display: "none",
          },
        },

        {
          key: "ContainerNo",
          mainkey: "ContainerNo",
          table: "B.",
          label: "Search Container",
          sortable: true,
          sortDirection: "ASC",
          thStyle: {
            display: "none",
          },
        },

        {
          key: "shippingLine",
          mainkey: "shippingLine",
          table: "S.",
          label: "Search ShippingLine",
          sortable: true,
          sortDirection: "ASC",
          thStyle: {
            display: "none",
          },
        },

        {
          key: "POD",
          mainkey: "POD",
          table: "D.",
          label: "Search POD",
          sortable: true,
          sortDirection: "ASC",
          thStyle: {
            display: "none",
          },
        },
        {
          key: "POR",
          mainkey: "POR",
          table: "C.",

          label: "Search POR",
          sortable: true,
          sortDirection: "ASC",
          thStyle: {
            display: "none",
          },
        },
      ],
      filtersCC: {
        clientName: "",
        ContainerNo: "",

        shippingLine: "",
        POD: "",
        POR: "",
      },
      perPageCC: 5,
      sortDescCC: false,
      sortByCC: null,
      sortDirectionCC: "asc",
      CCTrackDataImp: [],
      totalRowsCC: 0,
      currentPageCC: 1,
    };
  },
  methods: {
    onDownloadPDF(id) {
      this.isLoading = true;
      let type_Size = {
        excelData: "abc",
        excelId: id, //for CC =1,FF=2,TPT=3
        ffFromDateRngCC: this.searchModal.dateRangeCC[0],
        ffToDateRngCC: this.searchModal.dateRangeCC[1],
        searchValCC: this.filtersCC,
        fieldsCC: this.fieldsCC,
        searchVal: this.filtersFF,
        fields: this.fieldsFF,
        ffFromDateRng: this.searchModal.dateRangeFF[0],
        ffToDateRng: this.searchModal.dateRangeFF[1],
        ffFromDateRngTPT: this.searchModal.dateRangeTPT[0],
        ffToDateRngTPT: this.searchModal.dateRangeTPT[1],
        searchValTPT: this.filtersTPT,
        fieldsTPT: this.fieldsTPT,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/exportToExcel.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (id == "1") {
            }
            if (id == "2") {
            }
            if (id == "3") {
              if (data.TPTReportData.length > 0) {
                let mainArray = [];

                data.TPTReportData.map((x) => {
                  let tempArray = [];
                  this.columnsTPTpdf.map((y) => {
                    if (x.hasOwnProperty(y)) {
                      tempArray.push(x[y]);
                    }
                  });
                  mainArray.push(tempArray);
                });

                //var imgData = BASE64IMAGE;

                var doc = new jsPDF("l", "px", [1000, 600]);
                // doc.addImage(imgData, "JPEG", 340, 0, 60, 40);
                doc.text(
                  250,
                  53,
                  "PRIDEL TRANSPORTATION REPORT  "
                  // +
                  //   this.FromDate +
                  //   " TO " +
                  //   this.ToDate
                );
                // doc.text(230, 53, "GOGO CINEMA SHOW DATE REPORT FOR ");
                doc.setFontSize(17);

                doc.autoTable({
                  head: [this.columnsTPTpdf],
                  theme: "grid", // 'striped'|'grid'|'plain'
                  body: mainArray,
                  margin: { top: 60 },
                  headStyles: {
                    // fillColor: [209, 46, 30, 1]
                    // fillColor: [195, 66, 0]
                    fillColor: [210, 29, 29],
                  },
                });
                doc.save(
                  "TRANSPORTATION_REPORT" + new Date().toDateString() + ".pdf"
                );
              } else {
                //this.showMessageSnackbar("No data available");
              }
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    onDownloadExcel(id) {
      this.isLoading = true;
      let type_Size = {
        excelData: "abc",
        excelId: id, //for CC =1,FF=2,TPT=3
        ffFromDateRngCC: this.searchModal.dateRangeCC[0],
        ffToDateRngCC: this.searchModal.dateRangeCC[1],
        searchValCC: this.filtersCC,
        fieldsCC: this.fieldsCC,
        searchVal: this.filtersFF,
        fields: this.fieldsFF,
        ffFromDateRng: this.searchModal.dateRangeFF[0],
        ffToDateRng: this.searchModal.dateRangeFF[1],
        ffFromDateRngTPT: this.searchModal.dateRangeTPT[0],
        ffToDateRngTPT: this.searchModal.dateRangeTPT[1],
        searchValTPT: this.filtersTPT,
        fieldsTPT: this.fieldsTPT,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/exportToExcel.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (id == "1") {
              if (data.CCExcelData.length > 0) {
                var ccExcelReport = XLSX.utils.json_to_sheet(data.CCExcelData);
                var wb = XLSX.utils.book_new();
                wb.Title = "Insert Title Here";
                XLSX.utils.book_append_sheet(wb, ccExcelReport, "SheetOne"); // sheetAName is name of Worksheet
                // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons");
                XLSX.writeFile(
                  wb,
                  "CUSTOM_REPORT_" + new Date().toDateString() + ".xlsx"
                );
              } else {
                //this.showMessageSnackbar("No data available");
              }
            }
            if (id == "2") {
              if (data.FFExcelData.length > 0) {
                var ffExcelReport = XLSX.utils.json_to_sheet(data.FFExcelData);
                var wb = XLSX.utils.book_new();
                wb.Title = "Insert Title Here";
                XLSX.utils.book_append_sheet(wb, ffExcelReport, "SheetOne"); // sheetAName is name of Worksheet
                // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons");
                XLSX.writeFile(
                  wb,
                  "FREIGHT_REPORT_" + new Date().toDateString() + ".xlsx"
                );
              } else {
                //this.showMessageSnackbar("No data available");
              }
            }
            if (id == "3") {
              if (data.TPTReportData.length > 0) {
                var tptExcelReport = XLSX.utils.json_to_sheet(
                  data.TPTReportData
                );
                var wb = XLSX.utils.book_new();
                wb.Title = "Insert Title Here";
                XLSX.utils.book_append_sheet(wb, tptExcelReport, "SheetOne"); // sheetAName is name of Worksheet
                // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons");
                XLSX.writeFile(
                  wb,
                  "Transport_REPORT_" + new Date().toDateString() + ".xlsx"
                );
              } else {
                //this.showMessageSnackbar("No data available");
              }
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    // csvExport(csvDataFF) {
    //   let csvContent = "data:text/csv;charset=utf-8,";
    //   csvContent += [
    //     Object.keys(csvDataFF[0]).join("\n"),
    //     Object.keys(csvDataFF[0]).join("\n")
    //   ];
    //   console.log(Object.keys(csvDataFF[0]).join("\n"));
    //   // .join("\n")
    //   //  Object.keys(csvDataFF[0]).join("\n"),
    //   // csvDataFF.map(item => Object.values(item).join("\n"));
    //   // .replace(/(^\[)|(\]$)/gm, "");

    //   const data = encodeURI(csvContent);
    //   const link = document.createElement("a");
    //   link.setAttribute("href", data);
    //   link.setAttribute("download", "export.csv");
    //   link.click();
    // },

    getData() {
      this.isLoading = true;
      let type_Size = {
        user: "0",
        ffcctptFromDate: "",
        ffcctptToDate: "",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/dashboardData.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.msg == "Invalid Token") {
              this.$sessionsStorage.set("loginId", "");
              this.$store.dispatch("setCurrentRoute", "/Login/");
              this.$router.push({
                path: "/Login/",
              });
            } else {
              console.log(data, "pp");
              this.getAdvanceSearchDataCC("0", "1", "1");
              this.getAdvanceSearchDataFF("0", "1", "1");
              this.getAdvanceSearchDataTPT("0", "1", "1");
              if (data.$monthName.length > 0) {
                this.chartOptionsTPT3.xaxis.categories = data.$monthName;
              }
              if (data.$totalAssignExecuted.length > 0) {
                this.seriesTPT3[0].data = data.$totalAssignExecuted;
              }
              this.assignmentCount = data.assignmentCount;
              this.seriesTPT1.push(parseInt(data.completeAssignCount));
              this.seriesTPT1.push(data.pendingAssingment);
              this.chartOptionsTPT1.labels.push(
                "Completed - " + data.completeAssignCount
              );
              this.chartOptionsTPT1.labels.push(
                "Pending - " + data.pendingAssingment
              );
              this.chartOptionsTPT1.labels.push(
                "Total - " + data.assignmentCount
              );

              // this.chartOptionsTPT1.labels[1] =
              //   "Pending - " + data.pendingAssingment;
              // this.chartOptionsTPT1.labels[2] =
              //   "Total - " + data.assignmentCount;

              this.showChart = true;
              // this.totalClientCount = data.totalClientCount;
              // this.totalVehicleCount = data.totalVehicleCount;

              // this.seriesTPT1.push(parseInt(data.completeAssignCount));
              // this.seriesTPT1.push(data.pendingAssingment);
              // this.enquiryChart = data.enquiryChart;
              this.isLoading = false;
            }
          }
        })
        .catch((error) => {});
    },
    getAdvanceSearchDataFF(CURRENTFF, SEARCH, pageNumber) {
      this.isLoading = true;
      this.freightTrackDataExpo = [];

      let payLoad = {
        advanceSearch: "FF",
        searchVal: this.filtersFF,
        fields: this.fieldsFF,
        fromSearch: SEARCH,
        currentPageFF: CURRENTFF,
        perPageFF: this.perPageFF,
        ffFromDateRng: this.searchModal.dateRangeFF[0],
        ffToDateRng: this.searchModal.dateRangeFF[1],
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/dashboardAdvanceSearch.php`,
        data: JSON.stringify(payLoad),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (SEARCH != "2") {
              this.currentPageFF = 1;
              this.totalRowsFF = data.totalData;
            } else {
              this.currentPageFF = pageNumber;
            }
            if (data.freightTrackDataExpo.length > 0) {
              this.freightTrackDataExpo = data.freightTrackDataExpo;
            } else {
              this.freightTrackDataExpo = [];
            }

            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    getAdvanceSearchDataCC(CURRENTCC, SEARCHCC, pageNumberCC) {
      this.isLoading = true;
      this.CCTrackDataImp = [];

      let payLoad = {
        advanceSearch: "CC",
        searchValCC: this.filtersCC,
        fieldsCC: this.fieldsCC,
        fromSearchCC: SEARCHCC,
        currentPageCC: CURRENTCC,
        perPageCC: this.perPageCC,
        ffFromDateRngCC: this.searchModal.dateRangeCC[0],
        ffToDateRngCC: this.searchModal.dateRangeCC[1],
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/dashboardAdvanceSearch.php`,
        data: JSON.stringify(payLoad),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            if (SEARCHCC != "2") {
              this.currentPageCC = 1;
              this.totalRowsCC = data.totalDataCC;
            } else {
              this.currentPageCC = pageNumberCC;
            }
            if (data.CCTrackDataImp.length > 0) {
              this.CCTrackDataImp = data.CCTrackDataImp;
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    getAdvanceSearchDataTPT(CURRENTTPT, SEARCHTPT, pageNumberTPT) {
      this.isLoading = true;

      this.tptSearchData = [];

      let payLoad = {
        advanceSearch: "TPT",
        searchValTPT: this.filtersTPT,
        fieldsTPT: this.fieldsTPT,
        fromSearchTPT: SEARCHTPT,
        currentPageTPT: CURRENTTPT,
        perPageTPT: this.perPageTPT,
        ffFromDateRngTPT: this.searchModal.dateRangeTPT[0],
        ffToDateRngTPT: this.searchModal.dateRangeTPT[1],
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/dashboardAdvanceSearch.php`,
        data: JSON.stringify(payLoad),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (SEARCHTPT != "2") {
              this.currentPageTPT = 1;
              this.totalRowsTPT = data.totalDataTPT;
            } else {
              this.currentPageTPT = pageNumberTPT;
            }
            if (data.tptSearchData.length > 0) {
              this.tptSearchData = data.tptSearchData;
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    onConfirmDateRangeFF() {
      this.getAdvanceSearchDataFF("0", "1", "1");
    },
    onConfirmDateRangeCC() {
      this.getAdvanceSearchDataCC("0", "1", "1");
    },
    onConfirmDateRangeTPT() {
      this.getAdvanceSearchDataTPT("0", "1", "1");
    },
    onPageChangeFF: function (event) {
      let CURRENTFF = 0;
      if (event == "1") {
        CURRENTFF = 0;
      } else {
        CURRENTFF = event * this.perPageFF - this.perPageFF;
      }

      this.getAdvanceSearchDataFF(CURRENTFF, "2", event);
    },
    onPageChangeCC: function (eventCC) {
      let CURRENTCC = 0;
      if (eventCC == "1") {
        CURRENTCC = 0;
      } else {
        CURRENTCC = eventCC * this.perPageFF - this.perPageFF;
      }
      this.getAdvanceSearchDataCC(CURRENTCC, "2", eventCC);
    },
    onPageChangeTPT: function (eventTPT) {
      let CURRENTTPT = 0;
      if (eventTPT == "1") {
        CURRENTTPT = 0;
      } else {
        CURRENTTPT = eventTPT * this.perPageTPT - this.perPageTPT;
      }
      this.getAdvanceSearchDataTPT(CURRENTTPT, "2", eventTPT);
    },
  },
};
</script>

<style scoped>
.page-header {
  display: flex;

  align-items: center;
  margin: 1.5rem 2rem 1.5rem;

  justify-content: space-between;
  padding: 0;
  border-radius: 3px;
  position: relative;
  min-height: 50px;
}
.page-title {
  margin: 0;
  font-size: 25px;
  font-weight: 600;
  line-height: 2.5rem;
  position: relative;
  color: #2f2752;
}
.subpage-title {
  font-weight: 300;
  color: #43377b;
}
.topDivCard {
  margin: 1.5rem 2rem 1.5rem;
  /* border-radius: 25px; */
  position: relative;

  display: flex;

  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  box-shadow: -8px 12px 18px 0 rgba(25, 42, 70, 0.13);
  border-radius: 3px;
  border: 1px solid transparent;
  margin-bottom: 1.5rem;
  width: 100%;
}
.mb-3 {
  margin-bottom: -0.5rem !important;
  font-weight: 400 !important;
  color: #2f2752;
}
.mb-2 {
  margin-bottom: 0 !important;
  font-weight: 700 !important;
}
.mb-4 {
  margin-bottom: -0.5rem !important;
  font-weight: 700 !important;
}
.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// dashboardCcImpoReports.vue?2e3e26cc